import {GroupMsgMember} from "./group-msg-member";

export class GroupMsgThread {
    groupMsgThreadId: number;
    groupMsgMembers : Array<GroupMsgMember>;
    groupThreadName: string
}